import { lazy } from "react";
import { authRoleAccess } from '../../auth/AuthRoleAccess';

const POS = lazy(() => import("./POS"));

const posRoutes = [
    {
        path: "/pos",
        component: POS,
        auth: authRoleAccess.pos,
    },
];

export default posRoutes;
